export const tenantSettingsQueryKey = () => ["tenantSettings"] as const;

export const publicTenantSettingsQueryKey = () => ["publicTenantSettings"] as const;

export const companyDetailsQueryKey = () => ["companyDetails"] as const;

export const emailsListQueryKey = () => ["emailsList"] as const;

export const emailContentQueryKey = (type: string) => ["emailContent", type] as const;

export const emailContentHistoryQueryKey = (type: string, page?: number) =>
  page === undefined
    ? (["emailContentHistory", type] as const)
    : (["emailContentHistory", type, page] as const);
